import { render, staticRenderFns } from "./addPaper.vue?vue&type=template&id=168ac3d0&scoped=true"
import script from "./addPaper.vue?vue&type=script&lang=js"
export * from "./addPaper.vue?vue&type=script&lang=js"
import style0 from "./addPaper.vue?vue&type=style&index=0&id=168ac3d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168ac3d0",
  null
  
)

export default component.exports